import { TRACKING_OPERATION, TRACKING_SECTION, TRACKING_TARGET, TRACKING_TYPE } from '@/utils/constants';
import { dispatchTrack } from '..';
import { initStore } from '@/stores';

export enum LIVE_AGENT_UI_TYPE {
  BUBBLE = 'bubble',
  BUTTON_SHEET = 'bottom_sheet',
}

const reportSkip = (uiType: string, trackingSection: TRACKING_SECTION, buttonName: string | undefined) => {

  dispatchTrack({
    operation: TRACKING_OPERATION.SKIP,
    target: TRACKING_TARGET[TRACKING_TYPE.BUTTON],
    section: trackingSection,
    data: {
      ui_type: uiType,
      chat_session_id: initStore.sessionId || '',
      button_name: buttonName,
    },
  });
};

export default reportSkip;
